var map = {
	"./COLUMN.svg": "df8c",
	"./COLUMN_LEFT.svg": "8134",
	"./COLUMN_RIGHT.svg": "b031",
	"./COLUMN_TRANSPARENT_LEFT.svg": "11cb",
	"./GRID.svg": "7a19",
	"./TOP_ROW.svg": "d643",
	"./TOP_SHARE.svg": "a180",
	"./curve-down.svg": "9467",
	"./curve-up.svg": "f848",
	"./curve.svg": "bf96",
	"./focus.svg": "1f7e",
	"./menu.svg": "39c4",
	"./rotate_camera.svg": "7dfd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5981";